import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosInstance } from "../../../common/utils/AxiosInstance";
import { saveToLocalStorage } from "../../../common/utils/saveToLocal";
import { HMAC_SECRET_KEY } from "../../../config/api.config";
import CryptoJS from "crypto-js";





export const sendOTP = createAsyncThunk(
   "sendOTP",
   async (data, { rejectWithValue }) => {
      const URL = "/auth/otp/send";
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-signature": hmac,
            },
         })


         return { data, response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error?.response.data)))
      }
   }
)



export const resendOTP = createAsyncThunk(
   "resendOTP",
   async (data, { rejectWithValue }) => {

      const URL = "/auth/otp/resend"
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-signature": hmac,
            },
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error?.response.data)))
      }
   }
)

export const verifyOTP = createAsyncThunk(
   "verifyOTP",
   async (data, { rejectWithValue }) => {

      let URL = "/auth/otp/verify";
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-signature": hmac,
            },
         })

         localStorage.setItem('userId', res?.data?.data?.item?.userId);
         saveToLocalStorage('token', res?.data?.data?.item?.auth?.accessToken)
         saveToLocalStorage('tokenExpiryTime', res?.data?.data?.item?.auth?.accessTokenExpiryTime)
         saveToLocalStorage('refreshToken', res?.data?.data?.item?.auth?.refreshToken)
         saveToLocalStorage('refreshTokenExpiryTime', res?.data?.data?.item?.auth?.refreshTokenExpiryTime)
         return { loginMode: data.loginMode, response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue({
            response: error.response,
            status: error.response.status,
         })
      }
   }
)

/**
 * Test-login verify. Hits the backend test endpoint (`/auth/otp/verify/test`),
 * which logs in the QA number (9876543210) with the fixed OTP "1234" without a
 * real SMS. Same token-persistence behaviour as `verifyOTP` so the rest of the
 * app is unaware which path was used.
 */
export const verifyTestOTP = createAsyncThunk(
   "verifyTestOTP",
   async (data, { rejectWithValue }) => {

      let URL = "/auth/otp/verify/test";
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-signature": hmac,
            },
         })

         localStorage.setItem('userId', res?.data?.data?.item?.userId);
         saveToLocalStorage('token', res?.data?.data?.item?.auth?.accessToken)
         saveToLocalStorage('tokenExpiryTime', res?.data?.data?.item?.auth?.accessTokenExpiryTime)
         saveToLocalStorage('refreshToken', res?.data?.data?.item?.auth?.refreshToken)
         saveToLocalStorage('refreshTokenExpiryTime', res?.data?.data?.item?.auth?.refreshTokenExpiryTime)
         return { loginMode: data.loginMode, response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue({
            response: error.response,
            status: error.response.status,
         })
      }
   }
)

export const getMPIN = createAsyncThunk(
   "getMPIN",
   async (_, { rejectWithValue }) => {
      const URL = "/user/current/mpin";
      const token = JSON.parse(localStorage.getItem("token"));

      try {
         const res = await AxiosInstance.get(URL, {
            headers: {
               "x-auth-token": token,
            },
         });

         return { response: JSON.parse(JSON.stringify(res)) };
      } catch (error) {
         return rejectWithValue(error.response?.data || error.message);
      }
   }
);

export const verifyMPIN = createAsyncThunk(
   "auth/verifyMPIN",
   async (data, { rejectWithValue }) => {
      const URL = "/user/verify-mpin";
      const token = JSON.parse(localStorage.getItem("token"));
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();

      try {
         const response = await AxiosInstance.post(
            URL,
            data,
            {
               headers: {
                  "Content-Type": "application/json",
                  "x-auth-token": token,
                  "x-signature": hmac,
               },
            }
         );

         return { response: JSON.parse(JSON.stringify(response)) };
      } catch (error) {
         return rejectWithValue(error.response?.data || error.message);
      }
   }
);
export const updateMPIN = createAsyncThunk(
   "updateMPIN",
   async (_, { rejectWithValue }) => {
      const URL = "/user/current/mpin/update";
      const token = JSON.parse(localStorage.getItem("token"));
      const bodyJson = JSON.stringify(data);
      const hmac = CryptoJS.HmacSHA256(
         bodyJson,
         HMAC_SECRET_KEY
      ).toString();
      try {
         const res = await AxiosInstance.post(URL, data, {
            headers: {
               "x-auth-token": token,
               // "x-signature": hmac,
            },
         });

         return { response: JSON.parse(JSON.stringify(res)) };
      } catch (error) {
         return rejectWithValue(error.response?.data || error.message);
      }
   }
);


export const logoutUser = createAsyncThunk(
   "logoutUser",
   async (userType, { rejectWithValue }) => {

      const URL = "/user/logout"
      let token = "";
      let refreshToken = "";
      token = JSON.parse(localStorage.getItem("token"))
      refreshToken = JSON.parse(localStorage.getItem("refreshToken"))
      // if (userType === "servicePartner") {
      //    token = JSON.parse(localStorage.getItem("sptoken"))
      //    refreshToken = JSON.parse(localStorage.getItem("sprefreshToken"))
      // } else if (userType === "customer") {
      //    token = JSON.parse(localStorage.getItem("token"))
      //    refreshToken = JSON.parse(localStorage.getItem("refreshToken"))
      // }
      try {
         const res = await AxiosInstance.post(URL, {}, {
            headers: { "x-auth-token": token, "x-refresh-token": refreshToken }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error)))

      }
   }
)


export const refreshToken = createAsyncThunk(
   "refreshToken",
   async (userType, { rejectWithValue }) => {
      const URL = "/user/refreshToken"
      const token = JSON.parse(localStorage.getItem("token"))
      const refreshToken = JSON.parse(localStorage.getItem("refreshToken"))
      try {
         const res = await AxiosInstance.post(URL, {}, {
            headers: { "x-auth-token": token, "x-refresh-token": refreshToken }
         })

         saveToLocalStorage('token', res?.data?.data?.item?.auth?.accessToken)
         saveToLocalStorage('tokenExpiryTime', res?.data?.data?.item?.auth?.accessTokenExpiryTime)
         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return JSON.parse(JSON.stringify(rejectWithValue(error)))

      }
   }
)